var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIcd10Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46825 17.7038H41.4904L41.4004 14.9213C41.4004 14.9213 37.9011 13.4944 35.6431 13.6667C33.3861 13.84 20.8994 13.6959 20.8994 13.6959L17.6571 10.2061L7.62658 10.2645L6.64124 11.0143L6.46825 17.7038Z",
    fill: "#009DBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3728 30.2396H11.7092V23.8766H10.3728V30.2396Z",
    fill: "#0E2340"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5723 27.0559C12.5723 25.0052 13.7458 23.7656 15.5961 23.7656C17.1318 23.7656 18.3013 24.7361 18.4034 26.1611H17.1014C16.978 25.38 16.3751 24.8691 15.5961 24.8691C14.5865 24.8691 13.936 25.7116 13.936 27.0519C13.936 28.4104 14.5774 29.2478 15.6012 29.2478C16.3933 29.2478 16.9639 28.7853 17.1055 28.0304H18.4075C18.2578 29.4504 17.1642 30.3503 15.5961 30.3503C13.7367 30.3503 12.5723 29.1118 12.5723 27.0559Z",
    fill: "#0E2340"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5689 29.138H21.535C22.7297 29.138 23.3762 28.4144 23.3762 27.0388C23.3762 25.7066 22.7125 24.9749 21.535 24.9749H20.5689V29.138ZM21.6935 23.8765C23.6106 23.8765 24.7396 25.0142 24.7396 27.0338C24.7396 29.0543 23.6106 30.2404 21.6935 30.2404H19.2321V23.8765H21.6935Z",
    fill: "#0E2340"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6174 28.2512H28.5259V27.1266H25.6174V28.2512Z",
    fill: "#0E2340"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9257 25.0985H30.8994L29.2696 26.2181V25.0189L30.9216 23.8771H32.2499V30.24H30.9257V25.0985Z",
    fill: "#0E2340"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4028 27.0475C37.4028 25.6094 36.9374 24.7982 36.1807 24.7982C35.427 24.7982 34.9536 25.6145 34.9536 27.0475C34.9536 28.4936 35.4199 29.3139 36.1807 29.3139C36.9415 29.3139 37.4028 28.4976 37.4028 27.0475ZM33.5963 27.0475C33.5963 24.9917 34.5826 23.731 36.182 23.731C37.7804 23.731 38.7627 24.9876 38.7627 27.0434C38.7627 29.0983 37.7885 30.3811 36.182 30.3811C34.5745 30.3811 33.5963 29.1063 33.5963 27.0475Z",
    fill: "#0E2340"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9456 37.8056H10.0535C8.26084 37.8056 6.80306 36.3535 6.80306 34.5677V18.7016H41.197V34.5677C41.197 36.3535 39.7382 37.8056 37.9456 37.8056ZM8.16474 10.4904H17.1664L20.6586 13.9692H37.9456C39.3042 13.9843 41.3103 14.9336 41.197 17.197V17.4419H6.80306V11.8468C6.80306 11.0991 7.41308 10.4904 8.16474 10.4904ZM37.9456 12.7095H21.1826L18.0192 9.55823C17.8128 9.35366 17.5164 9.23071 17.226 9.23071H8.1647C6.71602 9.23071 5.53847 10.4047 5.53847 11.8468V34.5677C5.53847 37.0478 7.56378 39.0653 10.0534 39.0653H37.9456C40.4352 39.0653 42.4615 37.0478 42.4615 34.5677V17.197C42.4615 14.723 40.4352 12.7095 37.9456 12.7095Z",
    fill: "#0E2340"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcd10Icon);
export default __webpack_public_path__ + "static/media/icd10_icon.c9c36037aba59e6b125e1c2b17809aff.svg";
export { ForwardRef as ReactComponent };